import { sample } from 'effector';
import _ from 'lodash';
import {
    $isAdvisorClientPage,
    $isAdvisorClientsListPage,
    $isAdvisorGroupPage,
    $isAdvisorPanel,
    $isCommunity,
    $isDashboard,
    $isDocsGenerationPage,
    $isDocumentPage,
    $isEmployersPage,
    $isGiftTrustPage,
    $isPaymentPage,
    $isPrePaymentPage,
    $isSignupPage,
    $isSummaryPage,
    $isTacPage,
    $isTrustFundingPage,
    $isValidationPage,
    $location,
    $pathname,
    $queryParams,
    clearParams,
    setByKey,
    setParams,
} from 'models/location';
import navigate, { navigateFx } from 'models/router-gate';

import { objectToQS } from 'utils/common-helper';

setParams.use((newParams: { [key: string]: unknown }) => {
    const pathname = $pathname.getState();
    navigate(`${pathname}${objectToQS(_.pickBy(newParams, _.identity))}`);
});

clearParams.use(() => {
    const pathname = $pathname.getState();
    navigate(`${pathname}`);
});

setByKey.use(({ key, value }: { key: string; value: unknown }) => {
    const pathname = $pathname.getState();
    const params = $queryParams.getState();
    navigateFx(`${pathname}${objectToQS(_.pickBy({ ...params, [key]: value }, _.identity))}`);
});

sample({
    source: $location.map((location) => location.pathname),
    target: $pathname,
});

sample({
    source: $pathname.map((pathname) => pathname.startsWith('/document')),
    target: $isDocumentPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/payment')),
    target: $isPaymentPage,
});
sample({
    source: $pathname.map((pathname) => pathname.endsWith('/tac')),
    target: $isTacPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/summary')),
    target: $isSummaryPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/advisor/clients')),
    target: $isAdvisorClientsListPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/advisor/client/')),
    target: $isAdvisorClientPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/advisor/group')),
    target: $isAdvisorGroupPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/advisor')),
    target: $isAdvisorPanel,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/signup')),
    target: $isSignupPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/dashboard')),
    target: $isDashboard,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/community')),
    target: $isCommunity,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/employers')),
    target: $isEmployersPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/validate')),
    target: $isValidationPage,
});
sample({
    source: $pathname.map((pathname) => pathname === '/dashboard/trust-funding'),
    target: $isTrustFundingPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/dashboard/gift-trust')),
    target: $isGiftTrustPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/docs-generation')),
    target: $isDocsGenerationPage,
});
sample({
    source: $pathname.map((pathname) => pathname.startsWith('/pre-payment')),
    target: $isPrePaymentPage,
});
